var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05076 4C4.859 4 3 5.88012 3 8.3033C3 9.45992 3.43804 10.5599 4.20347 11.3636L12 19.55L19.7965 11.3636C20.562 10.5599 21 9.45992 21 8.3033C21 5.88012 19.141 4 16.9492 4C15.8911 4 14.8658 4.44091 14.1019 5.24296L12.7241 6.68966C12.5354 6.88784 12.2737 7 12 7C11.7263 7 11.4646 6.88784 11.2759 6.68966L9.89805 5.24296C9.1342 4.44091 8.10891 4 7.05076 4ZM1 8.3033C1 4.86862 3.6636 2 7.05076 2C8.6717 2 10.2158 2.67656 11.3463 3.86365L12 4.55L12.6537 3.86364C13.7842 2.67656 15.3283 2 16.9492 2C20.3364 2 23 4.86862 23 8.3033C23 9.95972 22.3738 11.5575 21.2448 12.743L12.7241 21.6897C12.5354 21.8878 12.2737 22 12 22C11.7263 22 11.4646 21.8878 11.2759 21.6897L2.75519 12.743C1.62622 11.5575 1 9.95972 1 8.3033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeLinear);
export default __webpack_public_path__ + "static/media/likeLinear.faef1ca6e32d30c88b9c3eee4c0c74e0.svg";
export { ForwardRef as ReactComponent };